export default "__VITE_ASSET__DP_Efcpg__"